<template>
  <div>
    <header>
      <top-menu />
    </header>
    <div class="head headersize" v-if="!mobileMode" />
    <shop-header-mobile :store-id="storeid" v-else />
    <section class="container">
      <slot />
    </section>
    <page-footer />
  </div>
</template>
<script>
import TopMenu from "./TopMenu.vue";
import PageFooter from "./footer.vue";

import ShopHeaderMobile from "./shopheaderMobile";
export default {
  components: {
    TopMenu,
    PageFooter,
    ShopHeaderMobile
  },
  props: {
    mobileMode: {
      type: Boolean,
      default: false
    }
  }
};
</script>
